export const CHANGE_ACTIVE_INPUT = 'CHANGE_ACTIVE_INPUT' as const;
export const SET_STATUSID_TRIP = 'SET_STATUSID_TRIP' as const;
export enum IntentionsTypes {
  Loading = 1,
  Unloading = 2,
}
